import React from 'react';
import { Logo } from './Logo';

interface MaintenancePageProps {
  onStaffLogin?: () => void;
}

export const MaintenancePage: React.FC<MaintenancePageProps> = ({ onStaffLogin }) => {
  const handleStaffClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (onStaffLogin) {
      onStaffLogin();
    } else {
      window.history.pushState({ page: 'admin' }, '', '/admin');
      window.dispatchEvent(new PopStateEvent('popstate'));
    }
  };

  return (
    <div
      id="maintenance-page-container"
      className="min-h-screen flex flex-col items-center justify-between bg-[#f8fafc] text-slate-800 px-4 py-8 relative overflow-hidden font-sans select-none"
    >
      {/* Background Soft Mesh Gradients */}
      <div className="fixed top-[-10%] left-[-10%] w-[55%] h-[55%] rounded-full bg-blue-100/60 blur-[130px] pointer-events-none z-0" />
      <div className="fixed bottom-[-10%] right-[-10%] w-[55%] h-[55%] rounded-full bg-sky-100/60 blur-[130px] pointer-events-none z-0" />

      {/* Top Spacer for Optical Centering */}
      <div className="w-full h-8" />

      {/* Center Card */}
      <div
        id="maintenance-card"
        className="relative z-10 w-full max-w-lg mx-auto text-center px-6 py-10 sm:py-12 bg-white/95 backdrop-blur-xl rounded-3xl border border-slate-200/80 shadow-xl shadow-slate-900/5 space-y-6"
      >
        <div className="flex justify-center pb-2">
          <Logo variant="full" size="lg" showTagline />
        </div>

        <div className="space-y-3">
          <h1 className="text-2xl sm:text-3xl font-extrabold text-[#001B48] font-heading tracking-tight">
            We'll be back shortly
          </h1>
          <p className="text-slate-600 text-base leading-relaxed max-w-md mx-auto">
            We're currently carrying out some improvements to the website. Please check back soon.
          </p>
        </div>

        <div className="pt-2 border-t border-slate-100">
          <p className="text-sm font-medium text-slate-500">
            Thank you for your patience.
          </p>
        </div>
      </div>

      {/* Discreet Staff Access Link */}
      <div className="relative z-10 w-full text-center pt-8 pb-4">
        <button
          id="maintenance-staff-access-btn"
          type="button"
          onClick={handleStaffClick}
          className="text-xs text-slate-400 hover:text-slate-600 transition-colors focus:outline-none focus:underline underline-offset-4 cursor-pointer"
        >
          Staff access
        </button>
      </div>
    </div>
  );
};
